import apiService from '@/services/apiService';

const actions = {
  getShowCases({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/showcase')
        .then((response) => {
          commit('getShowCases', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getShowCase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/showcase/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getShowCase', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getShowCaseAvailability({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/showcase/check-availability-before-create', payload)
        .then((response) => {
          resolve(response);
          commit('getShowCaseAvailability', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getShowCaseAvailabilityEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/showcase/check-availability-before-update', payload)
        .then((response) => {
          resolve(response);
          commit('getShowCaseAvailability', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  postShowCase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/showcase', payload)
        .then((response) => {
          commit('postShowCase', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateShowCases({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/showcase/update-status', payload)
        .then((response) => {
          const object = {};
          payload.forEach((value, key) => { object[key] = value; });
          const json = JSON.stringify(object);
          commit('updateShowCases', json);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putShowCase({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/showcase/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putShowCase', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delShowCase({ commit }, payload) {
    apiService.delete(`marketing/showcase/${payload}`)
      .then((response) => {
        commit('delShowCase', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
